import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "card", "count", "empty"]

  connect() {
    this.debounceTimer = null
    this.totalCount = this.cardTargets.length
    this.applyFilter()
  }

  filter() {
    clearTimeout(this.debounceTimer)
    this.debounceTimer = setTimeout(() => this.applyFilter(), 150)
  }

  applyFilter() {
    const query = this.hasInputTarget ? this.inputTarget.value.trim().toLowerCase() : ""
    let visible = 0
    this.cardTargets.forEach((card) => {
      const name = card.dataset.cardName || ""
      const desc = card.dataset.cardDescription || ""
      const match = !query || name.includes(query) || desc.includes(query)
      card.hidden = !match
      if (match) visible++
    })
    this.updateCount(visible)
    if (this.hasEmptyTarget) this.emptyTarget.hidden = visible > 0
  }

  updateCount(n) {
    if (!this.hasCountTarget) return
    this.countTarget.textContent = n === this.totalCount
      ? `${n} submissions`
      : `${n} of ${this.totalCount}`
  }
}
